import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatProgressBarModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcTextAreaInputModule } from '../fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { CommentStepComponent } from './components/comment-step/comment-step.component';
import { FinalStepComponent } from './components/final-step/final-step.component';
import { ScoreStepComponent } from './components/score-step/score-step.component';
import { NetPromoterScoreModalComponent } from './net-promoter-score-modal.component';
import { NetPromoterScoreModalService } from './net-promoter-score-modal.service';

@NgModule({
  declarations: [
    NetPromoterScoreModalComponent,
    ScoreStepComponent,
    CommentStepComponent,
    FinalStepComponent
  ],
  imports: [MatDialogModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatProgressBarModule, CommonModule, TranslateModule, PipesModule, FcTextAreaInputModule],
  providers: [NetPromoterScoreModalService],
  exports: [],
  entryComponents: [NetPromoterScoreModalComponent]
})
export class NetPromoterScoreModalModule {}
